<div class="screen-element screen-setvalue">
	<div #titleElement class="text title">{{title|uppercase}}</div>
	<div #titleElement class="text subtitle">{{subtitle}}</div>
	<div class="marker"></div>

	<div #wrapElement class="setvalue-elements-wrap">
		<div>
			<div class="setvalue-row">
				<div class="setvalue-item">
					<span class="">{{getValue()}}</span>
				</div>
			</div>
		</div>

	</div>
</div>